/*
 * Products Messages
 *
 * This contains all the text for the Products container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.Products';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'This is the Products container!',
  },
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Products',
  },
  new_product: {
    id: `${scope}.new_product`,
    defaultMessage: 'New product',
  },
  productCode: {
    id: `${scope}.productCode`,
    defaultMessage: 'Code',
  },
  description: {
    id: `${scope}.description`,
    defaultMessage: 'Description',
  },
  kit: {
    id: `${scope}.kit`,
    defaultMessage: 'KIT',
  },
  category: {
    id: `${scope}.category`,
    defaultMessage: 'Product line',
  },
  subcategory: {
    id: `${scope}.subcategory`,
    defaultMessage: 'Product subline',
  },
  domain: {
    id: `${scope}.domain`,
    defaultMessage: 'Field of use',
  },
  coverImage: {
    id: `${scope}.coverImage`,
    defaultMessage: 'Cover',
  },
  crmCategory: {
    id: `${scope}.crmCategory`,
    defaultMessage: 'Crm category',
  },
  supplier: {
    id: `${scope}.supplier`,
    defaultMessage: 'Supplier',
  },
  maxDiscount: {
    id: `${scope}.maxDiscount`,
    defaultMessage: 'Max discount',
  },
  active: {
    id: `${scope}.active`,
    defaultMessage: 'Active',
  },
  status: {
    id: `${scope}.status`,
    defaultMessage: 'Status',
  },
  yes: {
    id: `${scope}.yes`,
    defaultMessage: 'Yes',
  },
  onlyActive: {
    id: `${scope}.onlyActive`,
    defaultMessage: 'Only active',
  },
  onlyNotActive: {
    id: `${scope}.onlyNotActive`,
    defaultMessage: 'Only inactive',
  },
  all: {
    id: `${scope}.all`,
    defaultMessage: 'All',
  },
  productPrice: {
    id: `${scope}.productPrice`,
    defaultMessage: 'Price',
  },
});
